import React, { useEffect, useState } from 'react';
import { X, Image } from 'lucide-react';
import { galeriaService } from '../services/api';
import './Galeria.css';

export default function Galeria() {
  const [fotos,    setFotos]    = useState<any[]>([]);
  const [loading,  setLoading]  = useState(true);
  const [selected, setSelected] = useState<any>(null);

  useEffect(() => {
    galeriaService.listar()
      .then(r => setFotos(Array.isArray(r.data) ? r.data : r.data.fotos || []))
      .catch(() => setFotos([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main>
      <div className="page-hero">
        <h1>Galeria</h1>
        <p>Momentos especiais das ações e projetos do Instituto Mãos Estendidas.</p>
      </div>

      <section className="section-pad">
        <div className="container">
          {loading ? (
            <div className="loading-center"><div className="spinner" /><p>Carregando galeria…</p></div>
          ) : fotos.length === 0 ? (
            <div className="loading-center"><Image size={48} style={{ color: 'var(--borda)' }} /><p>Nenhuma imagem disponível.</p></div>
          ) : (
            <div className="galeria-grid">
              {fotos.map((f: any, i: number) => (
                <div
                  className="galeria-item"
                  key={f._id}
                  style={{ animationDelay: `${i * 0.05}s` }}
                  onClick={() => setSelected(f)}
                >
                  <img src={f.urlPublica || f.imagemUrl} alt={f.titulo || f.descricao || 'Foto'} loading="lazy" />
                  {(f.titulo || f.descricao) && (
                    <div className="galeria-overlay">
                      <p>{f.titulo || f.descricao}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selected && (
        <div className="lightbox" onClick={() => setSelected(null)}>
          <button className="lightbox-close" onClick={() => setSelected(null)}><X size={24} /></button>
          <div className="lightbox-img" onClick={e => e.stopPropagation()}>
            <img src={selected.urlPublica || selected.imagemUrl} alt={selected.titulo} />
            {(selected.titulo || selected.descricao) && (
              <p className="lightbox-caption">{selected.titulo || selected.descricao}</p>
            )}
          </div>
        </div>
      )}
    </main>
  );
}
